var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridlast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.83997H2V4.83997H0V6.83997ZM0 10.84H2V8.83997H0V10.84ZM0 2.83997H2V0.839966H0V2.83997ZM4 6.83997H18V4.83997H4V6.83997ZM4 10.84H18V8.83997H4V10.84ZM4 0.839966V2.83997H18V0.839966H4Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridlast);
export default __webpack_public_path__ + "static/media/gridlast.f22eab4ed66ab244d2147979a7a2566e.svg";
export { ForwardRef as ReactComponent };